import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZSite = z.object({
  id: z.string(),
  siteName: z.string()
})

const ZSiteApiResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  data: z.object({
    total_count: z.number(),
    sites: z.array(ZSite)
  }).nullable()
})

export type Site = z.infer<typeof ZSite>

// istanbul ignore next
export async function fetchSites (
  onSuccess: (sites: Site[], httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = '/assetrest/api/v2/udp/tiq/sites?page=1&pageSize=100'
  interceptedAxios
    .get(url, { timeout: 15000 })
    .then((response: any) => {
      const parseResponse = ZSiteApiResponse.safeParse(response.data)
      // istanbul ignore else
      if (parseResponse.success) {
        // istanbul ignore else
        if (
          parseResponse.data.data !== null &&
          parseResponse.data.data !== undefined
        ) {
          onSuccess(parseResponse.data.data.sites, response.status)
        } else {
          onFailure(parseResponse.data.error, response.status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error: any) => {
      onFailure(error.message, error.response.status)
    })
}
